import Questions from './questions';

function Profile(questionGroups, accountId) {
    this.questionGroups = questionGroups.map(function(questions) {
        return new Questions(questions, accountId);
    });
}

export default Profile;
